import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style, styleVariants } from '@vanilla-extract/css';

export const betaTagVariants = styleVariants({
  sm: {
    ...typography.bodySm,
    padding: `${space.s2}px ${space.s12}px`,
  },
  lg: {
    ...typography.bodyLg,
    padding: `${space.s6}px ${space.s20}px`,
  },
});

export const betaTag = style([
  {
    display: 'flex',
    borderRadius: borderRadius.r32,
    color: themeVars.nav.button.foreground.idle,
    border: `1px solid ${themeVars.nav.button.foreground.idle}`,
  },
]);
